enum VideoState
{
	Play,
	Pause
}

enum SoundState
{
	Muted,
	Unmuted
}

class VideoControls
{
	constructor(el: Element)
	{
		let playButton = el.querySelector<HTMLElement>(".video-controls__play");
		let soundButton = el.querySelector<HTMLElement>(".video-controls__sound");
		let transcriptButton = el.querySelector<HTMLElement>(".video-controls__transcript");
		let soundIcon = el.querySelector<HTMLElement>(".video-controls__sound .bx");
		let video = el.querySelector<HTMLVideoElement>("video");
		let buttonText = el.querySelector<HTMLSpanElement>(".video-controls__play span");
		let buttonIcon = el.querySelector<HTMLElement>(".video-controls__play .bx");
		let fullscreenButton = el.querySelector<HTMLElement>(".video-controls__fullscreen");
		let trackElement = el.querySelector<HTMLTrackElement>("track");
		let transcriptElement = el.querySelector<HTMLElement>(".video-controls__transcript-description");
		let autoplayCheckbox = el.querySelector<HTMLInputElement>(".disable-autoplay");

		// NEW INFO BOX
		let infoBox = el.querySelector<HTMLElement>(".video-controls__info");
		let infoIcon = infoBox?.querySelector<HTMLElement>(".bx-info-circle");

		let type = playButton?.querySelector(".bx-pause") ? VideoState.Play : VideoState.Pause;
		let soundType = SoundState.Muted;

		// Transcript toggle
		if (transcriptButton)
		{
			transcriptButton.addEventListener("click", () =>
			{
				if (trackElement && transcriptElement && trackElement.track.cues)
				{
					let container = document.createElement("div");
					container.classList.add("container");

					for (var i = 0; i < trackElement.track.cues.length; i++)
					{
						let cue = trackElement.track.cues[i] as any;
						let pTag = document.createElement("p");
						pTag.innerHTML = cue.text;
						container.appendChild(pTag);
					}
					transcriptElement.appendChild(container);
				}
			}, { once: true });
		}

		// Play / pause button
		if (playButton)
		{
			playButton.addEventListener("click", () => playFunc());
			playButton.addEventListener("keydown", (e) =>
			{
				if ((e as KeyboardEvent).key === "Enter") playFunc();
			});
		}

		// Sound toggle
		if (soundButton)
		{
			soundButton.addEventListener("click", () => playSound());
			soundButton.addEventListener("keydown", (e) =>
			{
				if ((e as KeyboardEvent).key === "Enter") playSound();
			});
		}

		// Fullscreen toggle
		if (fullscreenButton && video)
		{
			video.addEventListener("fullscreenchange", () =>
			{
				video?.classList.toggle("fullscreen");
			});

			fullscreenButton.addEventListener("click", () => fullScreenFunc());
			fullscreenButton.addEventListener("keydown", (e) =>
			{
				if ((e as KeyboardEvent).key === "Enter") fullScreenFunc();
			});
		}

		// Autoplay checkbox
		if (autoplayCheckbox)
		{
			// 1. On load: check localStorage and update UI / video
			const stored = localStorage.getItem("disableAutoplay");
			if (stored === "true")
			{
				autoplayCheckbox.checked = true;
				if (video)
				{
					video.autoplay = false;
					video.pause();
					playSound();
					type = VideoState.Pause;
					if (buttonText) buttonText.innerText = " Play";
					if (buttonIcon)
					{
						buttonIcon.classList.remove("bx-pause");
						buttonIcon.classList.add("bx-play");
					}
				}
			}

			// 2. On change: update video behaviour and save setting
			autoplayCheckbox.addEventListener("change", () =>
			{
				if (!video) return;

				if (autoplayCheckbox?.checked)
				{
					video.autoplay = false;
					video.pause();
					playSound();
					type = VideoState.Pause;
					if (buttonText) buttonText.innerText = " Play";
					if (buttonIcon)
					{
						buttonIcon.classList.remove("bx-pause");
						buttonIcon.classList.add("bx-play");
					}
					localStorage.setItem("disableAutoplay", "true");
				} else
				{
					video.autoplay = true;
					video.play();
					playSound();
					type = VideoState.Play;
					if (buttonText) buttonText.innerText = " Pause";
					if (buttonIcon)
					{
						buttonIcon.classList.add("bx-pause");
						buttonIcon.classList.remove("bx-play");
					}
					localStorage.setItem("disableAutoplay", "false");
				}
			});
		}



		if (infoBox && infoIcon)
		{
			const infoContent = infoBox.querySelector<HTMLElement>(".video-controls__info-box");

			if (infoContent)
			{
				// Optional: auto-open then hide
				infoContent.classList.add("active");
				setTimeout(() => infoContent.classList.remove("active"), 5000);

				// Toggle manually
				infoIcon.addEventListener("click", (e) =>
				{
					e.stopPropagation();
					infoContent.classList.toggle("active");
				});

				// Click outside to close
				document.addEventListener("click", (e) =>
				{
					if (!infoBox?.contains(e.target as Node))
					{
						infoContent.classList.remove("active");
					}
				});
			}
		}

		if (video)
		{
		
			video.addEventListener('ended', function ()
			{
				type = VideoState.Pause;

				if (buttonText) buttonText.innerText = " Play";

				if (buttonIcon)
				{
					buttonIcon.classList.remove("bx-pause");
					buttonIcon.classList.add("bx-play");
				}
			});
		}

		// --- Functions ---

		function playFunc()
		{
			if (!video) return;

			if (type === VideoState.Play)
			{
				video.pause();
				type = VideoState.Pause;
				if (buttonText) buttonText.innerText = " Play";
				if (buttonIcon)
				{
					buttonIcon.classList.remove("bx-pause");
					buttonIcon.classList.add("bx-play");
				}
			} else
			{
				video.play();
				type = VideoState.Play;
				if (buttonText) buttonText.innerText = " Pause";
				if (buttonIcon)
				{
					buttonIcon.classList.add("bx-pause");
					buttonIcon.classList.remove("bx-play");
				}
			}
		}

		function playSound()
		{
			if (!video) return;

			if (soundType === SoundState.Muted)
			{
				soundType = SoundState.Unmuted;
				video.muted = false;
				if (soundIcon)
				{
					soundIcon.classList.remove("bx-volume-mute");
					soundIcon.classList.add("bx-volume-full");
				}
			} else
			{
				soundType = SoundState.Muted;
				video.muted = true;
				if (soundIcon)
				{
					soundIcon.classList.remove("bx-volume-full");
					soundIcon.classList.add("bx-volume-mute");
				}
			}
		}

		function fullScreenFunc() 
		{
			if (!video) return;

			if (video.requestFullscreen)
			{
				video.requestFullscreen();
			} else if ((video as any).webkitEnterFullscreen)
			{
				(video as any).webkitEnterFullscreen();
			} else if ((video as any).webkitRequestFullscreen)
			{
				(video as any).webkitRequestFullscreen();
			} else if ((video as any).msRequestFullScreen)
			{
				(video as any).msRequestFullScreen();
			}
		}
	}
}

document.querySelectorAll(".video-controls").forEach(el =>
{
	new VideoControls(el);
});
